import styled from '@emotion/styled';
import Loader from '@/components/Loader/Loader';
import {
  FEEDBACK_BUTTON_HEIGHT,
  FEEDBACK_BUTTON_PADDING,
  HEADER_HEIGHT,
} from '@/layouts/MainLayout/utils/constants';

export const StyledPageLoader = styled(Loader)`
  margin-top: 0;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT});
`;

export const StyledLoaderWithPadding = styled(Loader)<{ padding: number }>`
  margin-top: 0;
  padding: ${({ padding }) => padding}px;
  width: 100%;
`;

export const StyledMainLoader = styled(Loader)`
  margin-top: 0;
  width: 100%;
  height: calc(
    100vh - ${FEEDBACK_BUTTON_HEIGHT} - (${FEEDBACK_BUTTON_PADDING} * 2) - ${HEADER_HEIGHT}
  );
`;
